$(document).ready(function() {
  
  $('.collection-filters-filter-all a').on('click', function() {
    var link = $(this);
    var bar = $('.collection-filters-bar-all');
    if (link.hasClass('active')) {
	  link.removeClass('active');
      bar.slideUp(250);
    } else {
      link.addClass('active');
      bar.slideDown(250);
    }
    return false;
  });
  $('.collection-filters-filter:not(.collection-filters-filter-all) a').on('click', function() {
    var link = $(this);
    var bar = $('.collection-filters-bar', link.closest('.collection-filters-filter'));
    if (link.hasClass('active')) {
	  link.removeClass('active');
      bar.slideUp(250);
    } else {
      $('.collection-filters-filter a.active').removeClass('active');
      $('.collection-filters-bar').hide();
      link.addClass('active');
      bar.slideDown(250);
    }
    return false;
  });
  $('.collection-filters-bar.collection-filters-bar-all .collection-filters-tab .collection-filters-label').on('click', function() {
    var link = $(this);
    var bar = $('.collection-filters-tab-content', link.closest('.collection-filters-tab'));
    if (link.hasClass('active')) {
	  link.removeClass('active');
      bar.slideUp(250);
    } else {
      link.addClass('active');
      bar.slideDown(250);
    }
    return false;
  });
  $('.collection-sort a').on('click', function() {
    var link = $(this);
    var bar = $('.collection-sort-bar');
    if (link.hasClass('active')) {
      link.removeClass('active');
      bar.slideUp(250);
    } else {
      link.addClass('active');
      bar.slideDown(250);
    }
    return false;
  });

  $('.collection-sort-bar a').on('click', function(e) {
    e.preventDefault()
    var scrollY = `&scroll.y=${window.scrollY}`;
    window.location.href = `${e.target.href}${scrollY}`;
  });

  $('.collection-line .collection-filters-bar .collection-filters-tab .collection-filters-tab-heading').on('click', function() {
    var tab = $(this).closest('.collection-filters-tab');
    tab.toggleClass('open');
    $('.collection-filters-tab-content', tab).slideToggle('normal');
  });
  $('.collection-line .collection-filters-bar .collection-filters-tab .collection-filters-tab-content .collection-filters-tab-content-value').on('click', function() {
    var checkbox = $('.checkbox', $(this));
    checkbox.toggleClass('checked');
  });
  $('.collection-filters-bar .apply-filters').on('click', function(e) {
    let $form = $(e.currentTarget).closest('.rs-collection-filters');
    var sort_by = '';
    if (window.location.href.indexOf('sort_by=') != -1) {
      var match = window.location.href.match(/sort_by=([^&]+)/);
      if (match != null) {
      	sort_by = match[1];
      }
    }
    var uri = collection_uri + '?sort_by=' + sort_by + '&filter.v.price.gte=' + $form.find('.filter-min-price').val() + '&filter.v.price.lte=' + $form.find('.filter-max-price').val();
    var checked = $form.find('.checkbox.checked');
    $.each(checked, function(k, v) {
      var filter = $(v).closest('.collection-filters-tab-content-value');
      uri += '&' + filter.data('param') + '=' + filter.data('value');
    });
    window.location.href = uri;
    var event = new CustomEvent("anchor:offset");
    document.dispatchEvent(event);
    return false;
  });
  
  if ($('#price-range').length > 0) {
    $('#price-range').slider({
      range: true,
      min: $('#price-range').data('min'),
      max: $('#price-range').data('max'),
      values: [$('#price-range').data('current-min'), $('#price-range').data('current-max')],
      slide: function(event, ui) {
        $('.collection-filters-prices .collection-filters-prices-input:first-child input').val(ui.values[0]);
        $('.collection-filters-prices .collection-filters-prices-input:last-child input').val(ui.values[1]);
      }
    });
    $('.collection-filters-prices .collection-filters-prices-input:first-child input').val($('#price-range').slider('values', 0));
    $('.collection-filters-prices .collection-filters-prices-input:last-child input').val($('#price-range').slider('values', 1));
  }
  
});

function buildUrlParams(searchParams, variable, value) {
  if(value && value != '0') {
    searchParams.set(variable, value);
  }
  return searchParams;
}